import * as _ from 'lodash';
import toastr from 'toastr';
import apiService from '../service/apiService';
import * as Utility from '../HelperMethods/UtilityFunctions';
import * as teamUilities from '../HelperMethods/TeamUtilities';
import { types as taskViewActionTypes } from '../components/taskView/TaskViewPage/redux/reducer';
import logUtils from '../HelperMethods/LogUtils';

export const types = {
  LOAD_TEAM_LIST_SUCCESS: 'LOAD_TEAM_LIST_SUCCESS',
  CREATE_TEAM_SUCCESS: 'CREATE_TEAM_SUCCESS',
  UPDATE_TEAM_SUCCESS: 'UPDATE_TEAM_SUCCESS',
  DELETE_TEAM_SUCCESS: 'DELETE_TEAM_SUCCESS',
  TEAM_LIST_LOADING_START: 'TEAM_LIST_LOADING_START',
  TEAM_LIST_LOADING_STOP: 'TEAM_LIST_LOADING_STOP',
};

function loadTeamsSuccess(response) {
  const teams = response.data.searchTeams.items;
  return { type: types.LOAD_TEAM_LIST_SUCCESS, teamList: teams };
}

async function loadUsersByTeams(teams) {
  const teamIds = teams.map((item) => item.id);
  const promise = [];
  while (teamIds.length) {
    const seedIds = teamIds.splice(0, 5);
    promise.push(apiService.getUsersByTeams(seedIds));
  }
  const users = await Promise.all(promise);
  let flatUsers = users.map((u) => u.data.getUsersByTeams).flatMap((val) => val);
  flatUsers = _.uniqBy(flatUsers, 'id');
  return flatUsers;
}

export function loadAllTeams(fieldId) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.TEAM_LIST_LOADING_START });
      const params = Utility.getSearchGraphQLParamForFieldId(fieldId);
      const response = await apiService.searchTeams(params);
      const teams = response.data.searchTeams.items;
      const usersResponse = await loadUsersByTeams(teams);
      Utility.mapTeamsToUsers(teams, usersResponse);
      dispatch(loadTeamsSuccess(response));
      return teams;
    } catch (error) {
      logUtils.logError(error, "Couldn't fetch teams data");
      dispatch({ type: types.TEAM_LIST_LOADING_STOP });
    }
  };
}

export function createTeamSuccess(savedTeam) {
  return (dispatch) => {
    dispatch({ type: types.CREATE_TEAM_SUCCESS, team: savedTeam });
  };
}

async function updateAreaForDeletedUserIDs(userIDs, teamId) {
  const areasResponse = await apiService.getAreasByTeams([teamId]);
  const areas = areasResponse.data.getAreasByTeams;
  const promises = [];
  const updatedAreas = teamUilities.getUpdatedAreas(userIDs, teamId, areas);
  updatedAreas.forEach((areaObj) => {
    promises.push(apiService.updateAsset(areaObj));
  });
  if (promises.length > 0) {
    await Promise.all(promises);
  }
}

function updateTeamsForUsers(teamId, state, existingTeam = {}) {
  const { updatedUser, deletedUser } = teamUilities.updateAddedDeletedUsers(teamId, state, existingTeam);
  const promises = [];
  updatedUser.forEach((user) => {
    promises.push(apiService.updateUser(user));
  });
  if (promises.length > 0) {
    Promise.all(promises);
  }
  if (!_.isEmpty(deletedUser)) {
    updateAreaForDeletedUserIDs(deletedUser, teamId);
  }
  return updatedUser;
}

export function createTeam(state, navigateToTeamList) {
  return async (dispatch) => {
    try {
      const createTeamInput = {};
      createTeamInput.name = state.team.name;
      createTeamInput.isDeleted = false;
      createTeamInput.fieldId = state.team.fieldId;
      createTeamInput.allowedTaskTypeCreateGroups = state.team.allowedTaskTypeCreateGroups;

      const response = await apiService.createTeam(createTeamInput);
      const savedTeam = response.data.createTeam;
      teamUilities.mapUsersToNewTeam(savedTeam, state);
      dispatch(createTeamSuccess(savedTeam));
      const updatedUsers = updateTeamsForUsers(savedTeam.id, state);
      dispatch({
        type: taskViewActionTypes.UPDATE_TEAMS_OF_USERS,
        updatedUsers,
      });
      toastr.success('Team Created Successfully!!');
      setTimeout(navigateToTeamList, 1000);
    } catch (error) {
      logUtils.logError(error, 'Team Creation Failed!!');
    }
  };
}

export function updateTeamSuccess(updatedTeam) {
  return (dispatch) => {
    dispatch({ type: types.UPDATE_TEAM_SUCCESS, team: updatedTeam });
  };
}

export function updateTeam(state, teamId, existingTeam, navigateToTeamList) {
  return async (dispatch) => {
    try {
      const updateTeamInput = {};
      updateTeamInput.name = state.team.name;
      updateTeamInput.id = teamId;
      updateTeamInput.isDeleted = false;
      updateTeamInput.allowedTaskTypeCreateGroups = state.team.allowedTaskTypeCreateGroups;
      const response = await apiService.updateTeam(updateTeamInput);
      const updatedTeam = response.data.updateTeam;
      teamUilities.mapUsersToNewTeam(updatedTeam, state);
      dispatch(updateTeamSuccess(updatedTeam));
      const updatedUsers = updateTeamsForUsers(updatedTeam.id, state, existingTeam);
      dispatch({
        type: taskViewActionTypes.UPDATE_TEAMS_OF_USERS,
        updatedUsers,
      });
      toastr.success('Team Updated Successfully!!');
      setTimeout(navigateToTeamList, 1000);
    } catch (error) {
      logUtils.logError(error, 'Team Update Failed!!');
    }
  };
}

export function deleteTeam(id) {
  return (dispatch) => {
    dispatch({ type: types.DELETE_TEAM_SUCCESS, id });
  };
}
